import React from "react";
import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
//theme
import theme from "../../../styles/theme.semantic";

function Title({ className, text, children, tag, tabIndex }) {
  switch (tag) {
    case "h1":
      return (
        <h1 tabIndex={tabIndex} className={className}>
          {children || text}
        </h1>
      );
    case "h3":
      return (
        <h3 tabIndex={tabIndex} className={className}>
          {children || text}
        </h3>
      );
    default:
      return (
        <h2 tabIndex={tabIndex} className={className}>
          {children || text}
        </h2>
      );
  }
}

Title.defaultProps = {
  tag: "h2"
};

Title.propTypes = {
  tag: PropTypes.string,
  text: PropTypes.string
};

const TitleWithStyles = styled(Title)`
  font-size: ${props => props.fontSize || "28px"};
  color: ${props => props.color || "#000"};
  cursor: ${props => props.cursor};
  line-height: ${props => props.lineHeight || "1.4"};
  font-style: ${props => props.fontStyle || "normal"};
  font-weight: ${props => props.fontWeight || "500"};
  margin-bottom: ${props => props.marginBottom};
  margin-top: ${props => props.marginTop};
  display: ${props => props.display};
  font-family: ${props =>
    props.alternativeStyle ? props.theme.type.serif : props.fontFamily};
  word-break: ${props => props.break};
  text-transform: ${props => props.textTransform};
  :first-letter {
    text-transform: ${props => props.firstLetter};
  }

  :focus {
    outline: 2px solid inherit;
  }

  // Medium devices (tablets, less than 992px)
  @media (max-width: 991px) {
    color: ${props => props.mobileMdColor};
  }

  // Small devices (landscape phones, less than 768px)
  @media (max-width: 767px) {
    font-size: ${props => props.mobileSmFontSize};
  }

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    font-size: ${props => props.mobileXsFontSize};
  }
`;

TitleWithStyles.defaultProps = {
  fontFamily: theme.components.title.fontFamily,
  alternativeStyle: false
};

TitleWithStyles.propTypes = {
  fontSize: PropTypes.string,
  color: PropTypes.string,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.string,
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontStyle: PropTypes.string,
  text: PropTypes.string,
  fontFamily: PropTypes.string,
  mobileSmFontSize: PropTypes.string,
  mobileXsFontSize: PropTypes.string,
  alternativeStyle: PropTypes.bool,
  mobileMdColor: PropTypes.string
};

export default TitleWithStyles;
